import { bdcRepository } from './Repository'
import { concatenationUrl } from '@/utils/index'

const resource = 'users'
export default {
  login({ email, password }) {
    const endpoint = `${resource}/login`

    return bdcRepository.post(`/${endpoint}`, {
      email: email,
      password: password,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
  getCustomers() {
    const endpoint = `${resource}/customers`

    return bdcRepository.get(`/${endpoint}`)
  },
  postMessage(message, subject, customerApiToken = null) {
    const endpoint = `${resource}/message`
    const qsParams = {
      customerApiToken: customerApiToken,
    }

    return bdcRepository.post(concatenationUrl`/${endpoint}?${qsParams}`, {
      message: message,
      subject: subject,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
  resetPassword(email) {
    const endpoint = `${resource}/reset-password/send`

    return bdcRepository.post(concatenationUrl`/${endpoint}`, {
      email: email,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
  checkResetPasswordToken(token) {
    const endpoint = `${resource}/reset-password/check-token`

    return bdcRepository.post(concatenationUrl`/${endpoint}`, { 
      token: token,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  },
  changePassword({ token, password }) {
    const endpoint = `${resource}/reset-password/change`

    return bdcRepository.post(concatenationUrl`/${endpoint}`, { 
      token: token, 
      password: password,
    }, {
      transformRequest: [(data) => JSON.stringify(data)],
    })
  }
}